import React from 'react';
import PropTypes from 'prop-types';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import Loading from 'layout/Loading';
import withDropdown from '../withDropdown';

const styles = theme => ({
  input: {
    paddingTop: 0,
    paddingBottom: 2,
  },
  caption: {
    color: theme.palette.primary.main,
  },
  row: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  paper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    display: 'table-cell',
    verticalAlign: 'unset !important',
  },
  centeredPaper: {
    width: 300,
    height: 267,
    [theme.breakpoints.down('xs')]: {
      height: 244,
    },
    display: 'table-cell',
    verticalAlign: 'middle',
  },
  title: {
    display: 'flex',
  },
});

export const ListBox = (props) => {
  const generateTable = (data) => {
    const { classes } = props;
    return data.map(entry => (
      <TableRow key={`${entry.key || (`${entry.measure_id}-${entry.code}`)}`}>
        <TableCell>
          <Typography className={classes.caption} variant="caption" gutterBottom>
            {entry.date}
          </Typography>
          <Typography variant="body1" gutterBottom>
            {entry.value}
          </Typography>
        </TableCell>
      </TableRow>
    ));
  };

  const {
    classes, data, loading, isWithDropdown, title,
  } = props;
  const hasData = data ? data.length > 0 : false;

  return (
    <div>
      {!isWithDropdown && (
        <Typography className={classes.title} variant="subheading">
          {title}
        </Typography>
      )}
      <Paper className={hasData ? classes.paper : classes.centeredPaper}>
        {loading ? <Loading /> : (
          hasData ? (
            <Table>
              <TableBody>
                {generateTable(data)}
              </TableBody>
            </Table>
          )
            : 'No available data'
        )}
      </Paper>
    </div>
  );
};

ListBox.defaultProps = {
  loading: false,
  isWithDropdown: false,
};

ListBox.propTypes = {
  data: PropTypes.oneOfType([PropTypes.shape(), PropTypes.arrayOf(PropTypes.shape())]).isRequired,
  title: PropTypes.string.isRequired,
  classes: PropTypes.shape({}).isRequired,
  loading: PropTypes.bool,
  isWithDropdown: PropTypes.bool,
};

export default withStyles(styles)(ListBox);
const ListBoxWithDropDown = withDropdown(withStyles(styles)(ListBox));
export { ListBoxWithDropDown };



// WEBPACK FOOTER //
// ./src/components/overview/ListBox/ListBox.jsx